import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';



if (environment.production) {
	enableProdMode();
	window.console.log		= () => {/* nope */};
	window.console.info		= () => {/* nope */};
	window.console.error	= () => {/* nope */};
}

const bootstrap = () => {
	return platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.log(err));
};

if (environment.hmr) {
	if ((module as any).hot) {
		hmrBootstrap(module, bootstrap);
	} else {
		console.error('HMR is not enabled!');
	}
} else {
	bootstrap();
}



// WEBPACK FOOTER //
// ./src/main.ts